import { DashboardAttentionPoint } from '@nebalkon-workspace/admin-api';
import {
  STAFF_ORDER_HOME_KIND_FILTER_IDS,
  STAFF_ORDER_HOME_STATUS_FILTER_IDS,
  StaffOrderHomeKindFilter,
  StaffOrderHomeStatusFilter,
} from '../orders/staff-order-filters.const';

export type StaffOrderTypeStatusCounts = Record<
  StaffOrderHomeStatusFilter,
  number
>;

export interface StaffOrderHomeStats {
  /** Сумма «новый» + «в обработке» по всем типам. */
  attentionTotal: number;
  byTypeAndStatus: Record<
    StaffOrderHomeKindFilter,
    StaffOrderTypeStatusCounts
  >;
}

function emptyMatrix(): StaffOrderHomeStats['byTypeAndStatus'] {
  const byTypeAndStatus = {} as StaffOrderHomeStats['byTypeAndStatus'];

  for (const type of STAFF_ORDER_HOME_KIND_FILTER_IDS) {
    const row = {} as StaffOrderTypeStatusCounts;
    for (const status of STAFF_ORDER_HOME_STATUS_FILTER_IDS) {
      row[status] = 0;
    }
    byTypeAndStatus[type] = row;
  }

  return byTypeAndStatus;
}

/** Maps dashboard attention matrix into the staff home widget shape. */
export function mapDashboardAttentionMatrix(
  points: DashboardAttentionPoint[],
  attentionTotal?: number,
): StaffOrderHomeStats {
  const byTypeAndStatus = emptyMatrix();
  let matrixTotal = 0;

  for (const point of points) {
    const type = point.type as StaffOrderHomeKindFilter;
    const status = point.status as StaffOrderHomeStatusFilter;
    const row = byTypeAndStatus[type];

    if (!row || !(status in row)) {
      continue;
    }

    row[status] = point.count;
    matrixTotal += point.count;
  }

  return {
    attentionTotal: attentionTotal ?? matrixTotal,
    byTypeAndStatus,
  };
}
